/**
 * Formats a job's duration for the work-orders list.
 *
 * The stored value is assumed to be HOURS (as it is on the job details page);
 * the `unit` argument is passed through but ignored. This mirrors the rest of the
 * app and should be reviewed if duration ever gains real multi-unit support.
 *
 * Under a day → hours ("8 hours"); a day or more → whole days, FLOORED ("10 days").
 * Floor (not round) is deliberate: it keeps the list consistent with the job detail
 * view, which floors too (e.g. 300h → detail "300 hours (12 days)", list "12 days").
 * Returns "—" for null/non-positive input.
 */

type DurationUnit = 'minutes' | 'hours' | 'days';

function pluralise(value: number, noun: string): string {
  return `${value} ${noun}${value === 1 ? '' : 's'}`;
}

export function formatDuration(value: number | null, _unit?: DurationUnit | null): string {
  if (value == null || value <= 0) return '—';

  if (value < 24) return pluralise(value, 'hour');

  return pluralise(Math.floor(value / 24), 'day');
}
